import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRights, useStore } from 'hooks';
import { useTour } from '../use-tour';
import { toast } from 'components/ui';
import { TOUR_REGISTRY } from '../tour.registry';

export const useCreateNewsTour = () => {
  const navigate = useNavigate();
  const { startTour, persistence } = useTour();
  const { onboardings, user } = useStore();

  const newsListRights = useRights('news');

  useEffect(() => {
    if (persistence.hasSeen('create_news', user.id) || !newsListRights.create) {
      return;
    }

    const tour = TOUR_REGISTRY['create_news'];

    const id = toast({
      title: 'Новые форматы публикаций!',
      description:
        'Мы расширили возможности. Теперь Вы можете создавать не только новости, но и оперативные события для жителей, а также служебные распоряжения для сотрудников.',
      actions: {
        acceptLabel: 'Показать, как это работает',
        cancelLabel: 'Пропустить',
        onAccept: () => {
          navigate('../create');
          startTour('create_news');
        },
        onCancel: () =>
          onboardings.patchOnboardingInfo(
            {
              block: 'create_news',
              viewed: true,
              version: tour.version,
            },
            user.id
          ),
      },
    });

    return () => {
      toast.dismiss(id);
    };
  }, []);
};
